const STATUS_MAP = {
  ACTIVE: { label: "AKTIF", cls: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  PENDING: { label: "MENUNGGU", cls: "bg-amber-50 text-amber-700 border-amber-200" },
  EXPIRED: { label: "TAMAT TEMPOH", cls: "bg-piks-border/40 text-piks-muted border-piks-border" },
  EXPIRING_SOON: { label: "AKAN TAMAT", cls: "bg-amber-50 text-amber-700 border-amber-200" },
  SUSPENDED: { label: "DIGANTUNG", cls: "bg-red-50 text-piks-red border-red-200" },
  INACTIVE: { label: "TIDAK AKTIF", cls: "bg-piks-border/40 text-piks-muted border-piks-border" },
  REVOKED: { label: "DIBATALKAN", cls: "bg-red-50 text-piks-red border-red-200" },
  BELUM_DITUNTUT: { label: "BELUM DITUNTUT", cls: "bg-sky-50 text-sky-700 border-sky-200" },
  DRAF: { label: "DRAF", cls: "bg-piks-border/40 text-piks-muted border-piks-border" },
  DIHANTAR: { label: "DIHANTAR", cls: "bg-blue-50 text-blue-700 border-blue-200" },
  DALAM_SEMAKAN: { label: "DALAM SEMAKAN", cls: "bg-amber-50 text-amber-700 border-amber-200" },
  PERLU_MAKLUMAT_TAMBAHAN: { label: "PERLU PEMBETULAN", cls: "bg-amber-50 text-amber-700 border-amber-200" },
  DILULUSKAN: { label: "DILULUSKAN", cls: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  DITOLAK: { label: "DITOLAK", cls: "bg-red-50 text-piks-red border-red-200" },
};

export function StatusBadge({ status, className = "" }) {
  const meta = STATUS_MAP[status] || { label: status, cls: "bg-piks-border/40 text-piks-muted border-piks-border" };
  return (
    <span
      data-testid={`status-badge-${status}`}
      className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-md border text-[11px] font-semibold tracking-wide ${meta.cls} ${className}`}
    >
      {meta.label}
    </span>
  );
}
